import styles from "./ValidationText.module.css";

export default function ValidationText({ title, body, emphasis }) {
  return (
    <section className={styles.section}>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.body}>{body}</p>
      <p className={styles.emphasis}>{emphasis}</p>
    </section>
  );
}
